import classNames from "classnames";
import React from "react";

interface IParams {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className: string;
}

const ThumbnailGridButton: React.FC<IParams> = ({ onClick, className }) => {
  return (
    <>
      <button
        className={classNames(className, "thumbnailButton")}
        onClick={onClick}
        color="ligth"
      >
        <i className="fas fa-th fa-2x customIconBorder"></i>
      </button>
    </>
  );
};

export default ThumbnailGridButton;
